var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "home" }, [
    _c("div", { staticClass: "bgc" }, [
      _c("div", { staticClass: "center" }, [
        _c("div", { staticClass: "top" }, [
          _vm._m(0),
          _vm._v(" "),
          _c("div", { staticClass: "day" }, [_vm._v(_vm._s(_vm.time))]),
          _vm._v(" "),
          _c("div", { staticClass: "day1" }, [
            _vm._v(_vm._s(_vm.year) + " " + _vm._s(_vm.day))
          ])
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "bottom" },
          _vm._l(_vm.list, function(item, index) {
            return _c(
              "div",
              {
                key: index,
                class: "list" + index,
                style: item.name == "交易中心" ? "color:#ccc" : "",
                on: {
                  click: function($event) {
                    return _vm.btn(index, item.path)
                  }
                }
              },
              [_vm._v(_vm._s(item.name))]
            )
          }),
          0
        )
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "logo" }, [
      _c("img", {
        attrs: {
          src: require("../assets/images/latast_pc/homeLogo.png"),
          alt: ""
        }
      })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a83bd3b0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a83bd3b0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/index.vue
// module id = null
// module chunks = 